import { render, staticRenderFns } from "./ConfigAddress.vue?vue&type=template&id=166afe9e&"
import script from "./ConfigAddress.vue?vue&type=script&lang=js&"
export * from "./ConfigAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports